/* eslint-disable react/prop-types */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FaLaptop } from '@react-icons/all-files/fa/FaLaptop';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import Link from 'gatsby-core-theme/src/hooks/link';
import { Context } from '~context/MainProvider';
import SportButtons from '../../atoms/sport-buttons';
import styles from './home-bottom-content.module.scss';

const HomeBottomContent = ({ pageContext }) => {
  const { translations } = useContext(Context) || {};
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.icon}>
          <FaLaptop />
        </div>
        <div className={styles.content}>
          <h4>
            {translate(translations, 'rage_ppc_homepage_bottom_Livestreaming', 'Live Stream')}
          </h4>
          <p>
            {translate(
              translations,
              'rage_ppc_homepage_bottom_text',
              'Watchfooty.co.uk gives you all the info you need on how to watch live streams of football, tennis and dart, 24/7 should you wish - with all leagues and matches covered.'
            )}
          </p>
          <Link to="/live-stream" className="home-buttom-content-gtm">
            {translate(translations, 'see_more_here', 'View the live streaming calendar >>')}
          </Link>
        </div>
      </div>
      <div className={styles.buttons}>
        <SportButtons
          sports={pageContext?.page?.relation?.sports}
          isHeader={false}
          prefix={translate(translations, 'go_to', 'Go to')}
          gtmClass="home-bottom-content-gtm"
        />
      </div>
    </div>
  );
};

HomeBottomContent.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({ relation: PropTypes.shape({}) }),
  }).isRequired,
};

export default HomeBottomContent;
